import React from 'react';

import { Route, RouteComponentProps, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const AuditLogsPage = lazyWithRetry(() => import('./AuditLogsPage'));
const AuditLogDetails = lazyWithRetry(() => import('./Details/AuditLogDetails'));

type Props = RouteComponentProps;

const AuditLogsRoutes: React.FC<React.PropsWithChildren<Props>> = (props: Props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="audit-logs">
      <Switch>
        <Route
          exact
          path={`${path}/:id`}
          render={(routeProps) => (
            <LazyComponent>
              <AuditLogDetails {...routeProps} />
            </LazyComponent>
          )}
        />
        <Route
          exact
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <AuditLogsPage />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default AuditLogsRoutes;
